/* eslint-disable */
// @ts-nocheck

declare let ga;

export const CLIENT_TRACKER_KEY = 'clientTracker';

export function initializeGoogleAnalyticsForClient(id: string, linkerEnabled: boolean, linkerDomains: string[]) {
  loadGoogleAnalytics();

  ga('create', { trackingId: id, cookieDomain: 'auto', allowLinker: linkerEnabled, name: CLIENT_TRACKER_KEY });
  ga(`${CLIENT_TRACKER_KEY}.set`, 'anonymizeIp', true);

  if (linkerEnabled) {
    ga(`${CLIENT_TRACKER_KEY}.require`, 'linker');
    ga(`${CLIENT_TRACKER_KEY}.linker:autoLink`, linkerDomains);
  }
}

export function disableGoogleAnalytics(id: string) {
  window[`ga-disable-${id}`] = true;
}

function loadGoogleAnalytics() {
  (function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function() {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * <any>new Date();
    a = s.createElement(o),
      m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
}
